module.exports = __webpack_public_path__ + "static/media/wifi-2.6143cdc5.svg";